<div>
    <div class="flex-centered-container-hr-column text-center">
        <div class="font-16 font-bold">
            <span>
                <mat-icon class="warning-logo text-neutral margin-top" *ngIf="!isSquaredOff">warning</mat-icon>
            </span>
        </div>



        <div class="margin-top">
            <span>{{data.message}}</span>
        </div>
        <div class="flex-space-between" *ngIf="!isSquaredOff">
            <button mat-flat-button color="accent" (click)="closeDialog()"
                class="ut-pro-button margin-top width-40 pad-4 gradient-warn border-radius-8 margin-left-24">
                Cancel
            </button>
            <button mat-flat-button color="accent" (click)="closeDialog(true)"
                class="ut-pro-button margin-top pad-4 width-40 gradient border-radius-8 margin-24-right">
                Proceed
            </button>
        </div>
        <div *ngIf="isSquaredOff">
            <button mat-flat-button color="accent" (click)="closeDialog()"
                class="ut-pro-button margin-top width-40 pad-4 gradient-warn border-radius-8 margin-left-24">
                OK
            </button>
        </div>
    </div>
</div>